var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-container"},[_c('multiselect',_vm._b({attrs:{"options":_vm.selectOptions,"searchable":false,"show-labels":false},on:{"input":_vm.onSelect}},'multiselect',_vm.$attrs,false),[_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('dashboard.label.listEmpty')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }